module.exports = __webpack_public_path__ + "static/logo-90b138c9cf04422abb241d285b0eda6d.png";